import ProcessApi from "../../service/ProcessService";
import LeadPartyApi from "../../service/LeadPartyService";
import TaskApi from "../../service/TaskService";

import AddNoteRequest from "../../service/request/AddNoteRequest";
import GetMyActiveTaskRequest from "../../service/request/GetMyActiveTaskRequest";
import AssignInitiatorToLeadPartyRequest from "../../service/request/AssignInitiatorToLeadPartyRequest";

export default {
  name: "AddNoteDialog",
  props: {
    processId: {
      type: String,
      required: true
    },
    leadPartyId: {
      type: Number,
      required: true
    }
  },
  mixins: [],
  computed: {
    rules: function() {
      return {
        descriptionRequired: v =>
          !!v || this.$t("description") + " " + this.$t("fieldRequired")
      };
    }
  },
  data: function() {
    return {
      description: "",
      isDroppingAssigneeInProgress: false
    };
  },
  created() {
    this.SHOW = true;
  },
  methods: {
    onClickCancel() {
      this.close();
    },
    onClickDropAssignee() {
      const isValid = this.$refs.dropAssigneeDialogForm.validate();
      if (isValid) {
        this.isDroppingAssigneeInProgress = true;

        const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
        getMyActiveTaskRequest.processId = this.processId;

        TaskApi.getMyActiveTask(
          this,
          getMyActiveTaskRequest,
          response => {
            const addNoteRequest = new AddNoteRequest();
            addNoteRequest.category = "NOTE_CATEGORY_DROPPED";
            addNoteRequest.description = this.description;
            addNoteRequest.processId = response.activeResourceTask.processId;

            ProcessApi.addNote(
              this,
              addNoteRequest,
              () => {
                const assignInitiatorToLeadPartyRequest = new AssignInitiatorToLeadPartyRequest();
                assignInitiatorToLeadPartyRequest.dropAssignee = true;

                LeadPartyApi.assignInitiator(
                  this,
                  response.activeResourceTask.processId,
                  assignInitiatorToLeadPartyRequest,
                  () => {
                    this.isDroppingAssigneeInProgress = false;
                    this.close();
                  },
                  error => {
                    console.log(error);
                    this.isDroppingAssigneeInProgress = false;
                  }
                );
              },
              error => {
                console.log(error, "error-addNote");
                this.isDroppingAssigneeInProgress = false;
              }
            );
          },
          error => {
            console.log(error);
            this.isDroppingAssigneeInProgress = false;
          }
        );
      }
    },
    close() {
      this.$emit("onClickCloseDropAssigneeDialog");
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/mixin/DropAssigneeDialog.js